import { observer } from 'mobx-react';
import { useRef } from 'react';
import { ExperienceVideoPreview, ExperienceViewLogo } from '../../../ProgramExperienceVideo';
import { useVisibilityObserver } from '../../../ProgramExperienceVideo/useVisibilityObserver';
import ExperiencesStore from '../../../../DiscoveryPortal/ExperienceSelection/Experiences/ExperiencesStore';

interface Props {
  className: string;
  height: number;
  experiencesStore: ExperiencesStore;
}

function ProgramExperienceCardVideo({ className, height, experiencesStore }: Props) {
  const placeholderRef = useRef<HTMLDivElement>(null);
  const hasBeenVisible = useVisibilityObserver(placeholderRef);

  if (!hasBeenVisible) {
    return <div ref={placeholderRef} className={className} />;
  }

  return (
    <ExperienceVideoPreview className={className} experiencesStore={experiencesStore}>
      <ExperienceViewLogo className={className} height={height} />
    </ExperienceVideoPreview>
  );
}

export default observer(ProgramExperienceCardVideo);
